import { Component, Inject, OnInit, Type, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import SignaturePad from 'signature_pad';
import jspdf from 'jspdf';
import { title } from 'process';

export interface SignatureContentData {
  entryComponent: Type<any>
  title: string
  message: string
  dataValues: any
  className:string
  undoCallback?: () => void
  clearCallback?: () => void
  saveCallback?: () => void
  cancleCallback?: () => void
}

@Component({
  selector: 'app-signature-pad-dialog',
  templateUrl: './signature-pad-dialog.component.html',
  styleUrls: ['./signature-pad-dialog.component.css']
})
export class SignaturePadDialogComponent implements OnInit {

  signPad: any;
  signImage:any;
  format="png"
  base64ImageData: any
  changeSignature = false
  savedSignature = false
  isSignature=false
  @ViewChild('signPadCanvas', {static: false}) signaturePadElement:any;
  

  constructor(
    public dialogRef: MatDialogRef<SignaturePadDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SignatureContentData
  ) { }

  ngOnInit(): void {
  }

  onCancle() {
    if (this.data.cancleCallback) {
      this.data.cancleCallback()
    }
    if(this.data.className && this.data.className=="HuntingDistrict" )
    this.dialogRef.close(this.data.dataValues.gameOriginData.jabSignature)

    if(this.data.className && this.data.className=="UserForm" )
    this.dialogRef.close([false, this.data.dataValues.signature])
  }

  onClear() {
    if (this.data.clearCallback) {
      this.data.clearCallback()
    }
    this.clearSignaturePad()
  }

  onUndo() {
    if (this.data.undoCallback) {
      this.data.undoCallback()
    }
    this.undoSignaturePad()
  }

  onSave() {
    if (this.data.saveCallback) {
      this.data.saveCallback()
    }
    this.saveSignaturePad()
    this.dialogRef.close([true,this.signImage])
  }


// Signature-pad functions

  ngAfterViewInit() {
    this.signPad = new SignaturePad(this.signaturePadElement.nativeElement);
    
  }
  startSignPadDrawing(event: Event) {
   
  }

  movedFinger(event: Event) {
  }

  printUrl(event: Event) {
   
  }

  //remove the last draw step
  undoSignaturePad() {
    const data = this.signPad.toData();
    if (data) {
      data.pop(); // 
      this.signPad.fromData(data);
    }
  }

  /*Clean all the pad*/
  clearSignaturePad() {
    this.signPad.clear();
  }

//THIS FUNCTION WILL DONLOAD THE FILE OF THE SIGNATURE
  downloadSign(signUrl: any){
    var linkDownload = document.createElement("a")
    document.body.appendChild(linkDownload)
    linkDownload.setAttribute("href", signUrl)
    linkDownload.setAttribute("download", "yoursignature."+this.format)
    linkDownload.click()
  }

  /*save the signature as a jpg/png/pdf*/
  saveSignaturePad() {
    switch(this.format){
      case'pdf' :{
        this.generatePDF()    
        break;
      }
      case 'png':{
        this.base64ImageData = this.signPad.toDataURL();//png
        this.signImage = this.base64ImageData;
        // this.downloadSign(this.base64ImageData)
        break;
      }
      case 'jpg':{
        this.base64ImageData = this.signPad.toDataURL("jpg");//png
        this.signImage = this.base64ImageData;
        // this.downloadSign(this.base64ImageData)
      }
      
    }
    this.savedSignature=true
    this.isSignature=true
    this.changeSignature=false
  }

  selectFormat(){
  
  }

  generatePDF(){
    // let fileWidth = 108;
    
    // let fileHeight = 100 * fileWidth / 300
    // const FILEURI = this.signPad.toDataURL(1.0)
    // let PDF = new jspdf('p', 'mm', 'a4');
    // let position = 30;
    // PDF.addImage(FILEURI, 'PNG',30, position, 50, 20,'LOW');
    // this.districtForm.value.jabSignature=FILEURI
    // this.data.data.gameOriginData.jabSignature=FILEURI
    // PDF.save('angular-demo.pdf');
  }

  async changeSignaturePad(){
    // this.changeSignature=true
    // this.savedSignature=false
    // // this.data.data.gameOriginData.jabSignature.delete
    // // await this.data.removeListener(this.data.data.gameOriginData.jabSignature)
    // this.data.data.gameOriginData.jabSignature=""
    // this.isSignature=false
    // await this.createSignaturaPad()
  }







}
